import type { FaqProps, FaqItem } from '../../../components/Faq/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { ComponentType } from '../../registries/types/propTypes';

const transformFaq = (data: CMSTransformerDataType): FaqProps => {
  const faqData = Array.isArray(data?.faqs) ? data?.faqs[0] : data?.faqs;
  const faqQuestionAnswer: FaqItem[] = faqData?.faqs.map((faq_item: CMSTransformerDataType) => ({
    question: faq_item.question,
    answer: faq_item.answer,
  }));

  return {
    displayTitle: faqData?.display_title,
    faqQuestionAnswer,
    componentType: ComponentType.faq,
    sanitize: faqData.sanitize ?? false,
    sanitizationConfig: faqData.sanitizationConfig ?? {},
  };
};

export default transformFaq;
